import { render, staticRenderFns } from "./BookingInterviews.vue?vue&type=template&id=5bdbb915&"
import script from "./BookingInterviews.vue?vue&type=script&lang=js&"
export * from "./BookingInterviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports